import AuthService from "@/core/services/Auth.service";
import { sessionRepository } from "@/infrastructure/repositories/session/Session.repository";

let loggingOut = false;

/**
 * Clears the studio session and triggers Auth0 logout (when wired).
 * Safe to call from HTTP/GraphQL adapters outside React.
 */
export function forceSessionLogout(): void {
  if (loggingOut) {
    return;
  }
  loggingOut = true;
  sessionRepository.clear();
  AuthService.getInstance().runLogoutHandler();
}

/** Test-only: resets the in-flight logout guard. */
export function resetForceSessionLogoutForTests(): void {
  loggingOut = false;
}
